import { initializeApp } from "firebase/app";
import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from "firebase/remote-config";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import pjson from "../package.json";
import getEnvironment from "./utils/getEnvironment";
import { fireBaseDefaults, firebaseConfig } from "./utils/firebaseDefaults";

let remoteConfig;

const { isLocal, isDev } = getEnvironment();

const firebaseCachetime = isLocal || isDev ? 600000 : 3600000;

export async function setupFirebaseRemoteConfig() {
  const firebaseApp = initializeApp(firebaseConfig);
  remoteConfig = getRemoteConfig(firebaseApp);

  remoteConfig.settings.minimumFetchIntervalMillis = firebaseCachetime;
  remoteConfig.settings.fetchTimeoutMillis = firebaseCachetime;

  remoteConfig.defaultConfig = fireBaseDefaults;

  await fetchAndActivate(remoteConfig);
}

export function getRemoteConfigValue(key) {
  return getValue(remoteConfig, key);
}

export function getRemoteValueEnv(devKey, proKey) {
  return isDev || isLocal
    ? getRemoteConfigValue(devKey)
    : getRemoteConfigValue(proKey);
}

export function setupDatadog() {
  console.log("Versão: " + pjson.version);
  let sampleRate = parseInt(
    getRemoteConfigValue("datadog_sample_rate").asNumber()
  );
  let traceRate = parseInt(
    getRemoteConfigValue("datadog_trace_rate").asNumber()
  );
  datadogRum.init({
    applicationId: "22d1a2c7-5fa2-485e-88b1-cabe136fc845",
    clientToken: "pub1f9fd56540ea6cd6d4ee38eb7c734911",
    site: "datadoghq.com",
    service: "bot2.0",
    env: process.env.NODE_ENV === "production" ? "production" : "development",
    version: pjson.version,
    sessionSampleRate: sampleRate,
    sessionReplaySampleRate: sampleRate,
    traceSampleRate: traceRate,
    defaultPrivacyLevel: "allow",
    plugins: [reactPlugin({ router: true })],
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    allowedTracingUrls: [
      (url) =>
        url.includes("mycon.com.br") || url.includes("mycon-bot.pages.dev"),
    ],
  });
}
